import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'bst-sparkline',
  templateUrl: './sparkline.component.html',
  styleUrls: ['./sparkline.component.scss'],
  standalone: false
})
export class SparklineComponent implements AfterViewInit, OnChanges {
  @Input() values: number[] = [];
  @Input() width  = 80;
  @Input() height = 22;

  @ViewChild('svg', { static: true }) svgRef!: ElementRef<SVGSVGElement>;

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnChanges(_: SimpleChanges): void {
    if (this.svgRef) {
      this.render();
    }
  }

  private render(): void {
    const svg = d3.select(this.svgRef.nativeElement);
    svg.selectAll('*').remove();

    if (!this.values?.length) return;

    const xScale = d3.scaleLinear()
      .domain([0, Math.max(this.values.length - 1, 1)])
      .range([1, this.width - 1]);

    const yMin = Math.min(...this.values);
    const yMax = Math.max(...this.values);
    const yScale = d3.scaleLinear()
      .domain([yMin, yMax === yMin ? yMax + 1 : yMax])
      .range([this.height - 2, 2]);

    const line = d3.line<number>()
      .x((_d, i) => xScale(i))
      .y(d => yScale(d))
      .curve(d3.curveMonotoneX);

    svg.append('path')
      .attr('d', line(this.values))
      .attr('fill', 'none')
      .attr('stroke', 'currentColor')
      .attr('stroke-width', 1.5);
  }
}
